module.exports = __webpack_public_path__ + "img/luontopolku_original.3bf95809.png";